import React from "react";

import Header from "../Header";
import Footer from "../Footer";


export default function Links () {
    
    return (
        
        <div className="page page_project page-edit">
        
            <Header />
            
            <main>
                <div className="content">
                
                    <div className="page__title">
                        <h1 className="links-h1">Pages</h1>   
                    </div>
                    
                </div>
                        
                <div className="content">
                
                    <div className="links">
                    
                    
                        <a href="/login">Login</a>
                        <a href="/projects">Projects</a>
                        <a href="/project">Project</a>
                        <a href="/create">Create</a>
                        <a href="/create_activity">Create Activity</a>
                        <a href="/create_quiz">Create Quiz</a>
                        <a href="/create_module1">Create Module 1</a>
                        <a href="/create_module2">Create Module 2</a>
                        <a href="/edit">Edit</a>
                        <a href="/edit_quiz">Edit quiz</a>
                        <a href="/examples">Firebase examples</a>
                        
                        
                    </div>                    

                </div>
            </main>
            
            <Footer />            
            
        </div>
    )
        
}

